<template>
	<main>
		<LoginForm @loginSuccess="redirectToStart" />
	</main>
</template>

<script>
import LoginForm from '../components/LoginForm'
import auth from '../auth'

export default {
	name: 'Login',
	components: {
		LoginForm,
	},
	methods: {
		redirectToStart() {
			this.$router.replace(auth.getLoginRedirect() ||'/command');
		},
	},
};
</script>
